import TopEngagedTeachers from './TopEngagedTeachers';
import EducatorDayOfWeek from './EducatorDayOfWeek';
import PopularGames from './PopularGames';
import MostReadStories from './MostReadStories';
import styles from './SchoolReport.module.scss';
import { SchoolReportState } from './SchoolReport';

const SchoolDashboard = ({
  legacyPlatformEvents,
  legacyPlatformEventsReady,
  legacyPeekavilleEvents,
  legacyPeekavilleEventsReady,
  newMixpanelEvents,
  newMixpanelEventsReady,
  selectedSchoolYear,
  teacherClassroomMaps,
  teacherClassroomMapsReady,
  userListReady,
  userList,
  gameProgressMap,
  gameProgressMapReady,
}: SchoolReportState) => {
  return (
    <div className={styles.schoolDashboard}>
      <div className={styles.gutterContainer}>
        <TopEngagedTeachers
          teacherClassroomMaps={teacherClassroomMaps}
          teacherClassroomMapsReady={teacherClassroomMapsReady}
          selectedSchoolYear={selectedSchoolYear}
          legacyPlatformEvents={legacyPlatformEvents}
          legacyPlatformEventsReady={legacyPlatformEventsReady}
          legacyPeekavilleEvents={legacyPeekavilleEvents}
          legacyPeekavilleEventsReady={legacyPeekavilleEventsReady}
          newMixpanelEvents={newMixpanelEvents}
          newMixpanelEventsReady={newMixpanelEventsReady}
          userListReady={userListReady}
          userList={userList.list}
        />
        <EducatorDayOfWeek
          legacyPlatformEvents={legacyPlatformEvents}
          legacyPlatformEventsReady={legacyPlatformEventsReady}
          legacyPeekavilleEvents={legacyPeekavilleEvents}
          legacyPeekavilleEventsReady={legacyPeekavilleEventsReady}
          newMixpanelEvents={newMixpanelEvents}
          newMixpanelEventsReady={newMixpanelEventsReady}
        />
        <PopularGames
          gameProgressMap={gameProgressMap}
          gameProgressMapReady={gameProgressMapReady}
        />
        <MostReadStories
          legacyPlatformEvents={legacyPlatformEvents}
          legacyPeekavilleEvents={legacyPeekavilleEvents}
          newMixpanelEvents={newMixpanelEvents}
          eventsReady={legacyPlatformEventsReady && legacyPeekavilleEventsReady && newMixpanelEventsReady}
        />
      </div>
    </div>
  );
};

export default SchoolDashboard;
